__webpack_require__.p = "/kidclass/web/";